const setResumeReferences = (references) => ({
    type: 'SET_RESUME_REFERENCES',
    references,
});

export default setResumeReferences;
